'use client';

import { ReactNode, useMemo, useState } from 'react';
import { Button } from '@/components/ui/button';
import { useRouter, usePathname } from 'next/navigation';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn, isEn } from '@/lib/utils';

import {
  CheckCircleFillIcon,
  ChevronDownIcon,
  GlobeIcon,
  LockIcon,
  PlusIcon,
} from '../icons';
// import { DefaultNavLink, medialinks, navLinkNull, navlinks, toollinks } from '@/app/(work)/layout-left/main-sidebar';
import { toast } from 'sonner';
import React from 'react';
import { FloatingActionPanelContent, FloatingActionPanelRoot, FloatingActionPanelTrigger } from '../aceternity/floating-action-panel';
import { ComicText } from '../magicui/text/comic-text';
import { motion } from 'framer-motion';
import { sslog } from '@/lib/utils/sslog';
import { NavLink } from '@/lib/type';


// export const navlinks_orige:NavLink[] = [

//   // { label: "💬 咨询顾问", title: "交互与引导通用工作流 (Interaction & Guidance)",  href: "#guidance", type: "basic" },
//   // { label: "🎓 学习导师", title: "认知构建通用工作流 (Cognition & Mastery)",  href: "#tutor", type: "basic" },
//   // { label: "🔍 研究员", title: "研究与分析通用工作流 (Research & Analysis)",  href: "#researcher", type: "basic" },
//   // { label: "🧠 创作者", title: "创造与生成通用工作流 (Creation & Generation)",  href: "#producer", type: "basic" },
//   // { label: "✅ 质检员", title: "优化与校验通用工作流 (Optimization & Validation)",  href: "#validator", type: "basic" },

//   // 分隔符
//   // { label: "", title: "", href: "", type: "separator" },
//   // 基础工作流
//   { label: "💬 咨询顾问", title: "交互与引导通用工作流",  href: "#guidance", type: "basic" },
//   { label: "🎓 学习导师",  title: "认知构建项目化AI辅助流程",  href: "#tutor", type: "basic" },
//   { label: "🔍 研究员", title: "研究与分析通用工作流",  href: "#researcher", type: "basic" },
//   { label: "🧠 创作者", title: "创造与生成通用工作流",  href: "#producer", type: "basic" },
//   { label: "✅ 质检员", title: "优化与校验通用工作流",  href: "#validator", type: "basic" },
//   { label: "🧠 通识协作", title:  "通用创作项目化AI协作流程",  href: "#allbasic", type: "basic" },
//   // 特定场景工作流
//   { label: "🏛️ 战略决策", title: "战略分析与研判决策项目化协作流程", href: "#strategy", type: "scenario" },
//   { label: "📈 推广运营", title: "市场分析和推广营销项目化协作流程", href: "#promotion", type: "scenario" },
//   { label: "🎨 产品设计", title: "产品设计和体验优化项目化协作流程", href: "#product-design", type: "scenario" },
//   { label: "💻 软件开发", title: "软件开发和工程实践项目化协作流程", href: "#software-dev", type: "scenario" },
//   { label: "🃏 图文卡片", title: "自媒体图文创作项目化协作流程", href: "#graphic-card", type: "scenario" },
//   { label: "📝 媒体文案", title: "自媒体平台文案项目化协作流程", href: "#copywriting", type: "scenario" },
//   { label: "📚 小说创作", title: "中长篇小说创作项目化协作流程", href: "#novel-creation", type: "scenario" },
//   { label: "🎵 音乐工坊", title: "音乐歌词曲谱创作项目化协作流程", href: "#music-workshop", type: "scenario" },
//   { label: "🎬 电影编剧", title: "电影剧本脚本创作项目化协作流程", href: "#screenplay", type: "scenario" },
// ]

// export const navlinks_qwen:NavLink[] = [
//   // 基础工作流
//   { label: "💬 咨询顾问", title: "与你并肩思考的答疑与指引流程", href: "#guidance", type: "basic" },
//   { label: "🎓 学习导师", title: "和AI一起搭建知识框架、完成学习计划", href: "#tutor", type: "basic" },
//   { label: "🔍 研究员", title: "协同深挖资料、整理洞察思路的研究流程", href: "#researcher", type: "basic" },
//   { label: "🧠 创作者", title: "灵感到成稿的AI共创流程", href: "#producer", type: "basic" },
//   { label: "✅ 质检员", title: "帮你查错打磨、提升质量的全程协作", href: "#validator", type: "basic" },
//   { label: "🧠 通识协作", title: "多领域创作与项目推进的一站式AI协作", href: "#allbasic", type: "basic" },
//   // 特定场景工作流
//   { label: "🏛️ 战略决策", title: "与AI共研策略、帮你看清全局的决策流程", href: "#strategy", type: "scenario" },
//   { label: "📈 推广运营", title: "从市场调研到活动方案的全链路AI协作", href: "#promotion", type: "scenario" },
//   { label: "🎨 产品设计", title: "和AI一起描绘创意、优化用户体验", href: "#product-design", type: "scenario" },
//   { label: "💻 软件开发", title: "从构想到代码实现的AI辅助开发流程", href: "#software-dev", type: "scenario" },
//   { label: "🃏 图文卡片", title: "AI帮你快速产出有吸引力的图文作品", href: "#graphic-card", type: "scenario" },
//   { label: "📝 媒体文案", title: "灵感速来，和AI一起写出打动人的文案", href: "#copywriting", type: "scenario" },
//   { label: "📚 小说创作", title: "打造人物和剧情的长篇AI共创之旅", href: "#novel-creation", type: "scenario" },
//   { label: "🎵 音乐工坊", title: "与AI谱写旋律歌词的创作流程", href: "#music-workshop", type: "scenario" },
//   { label: "🎬 电影编剧", title: "和AI共写剧本、构建精彩故事世界", href: "#screenplay", type: "scenario" },
// ]

// gemini：
export const SettingNavLink:NavLink =  isEn ? { label: "System Settings", title: "System or user data configuration",  href: "#system",  type: "system" }
                                            : { label: "系统设置", title: "系统或用户数据配置",  href:"#system",   type: "system" };
// export const DefaultNavLink:NavLink =  isEn ? { label: "💬 Consultant", title: "Clarify your thinking and make decisions—AI walks you step-by-step to find a solution",  href: "#guidance", type: "basic" }
//                                             : { label: "💬 咨询顾问", title: "梳理思路清晰决策，AI陪你一步步找到解决方案",  href: "#guidance", type: "basic" };

export const DefaultNavLink:NavLink = SettingNavLink;

export const navlinks_backup:NavLink[] = [
  // SettingNavLink,
  // 基础工作流
  // { label: "🎓 学习导师",  title: "搭建你的知识体系，从新手到专家",  href: "#tutor", type: "basic" },
  // { label: "🔍 研究员", title: "深入挖掘信息，让AI助你洞察先机",  href: "#researcher", type: "basic" },
  // { label: "✨ 创作者", title: "释放你的想象力，将灵感火花变为杰作",  href: "#producer", type: "basic" },
  // { label: "✅ 质检员", title: "字斟句酌，AI帮你打磨出完美作品",  href: "#validator", type: "basic" },
  // { label: "🤝 通识协作", title: "多角色协同，全面提升创作效能", href: "#allbasic", type: "basic" }, // 图标修改
  // { label: "🤝 通识协作", title: "多领域创作与项目推进的通用AI协作", href: "#allbasic", type: "basic" },
  { label: "💬 咨询顾问", title: "梳理思路清晰决策，一步步找到解决方案",  href: "#guidance", type: "basic" },
  { label: "🤝 全能创作", title: "多领域创作与项目推进，达成一站式协作", href: "#allbasic", type: "basic" },
  { label: "🎓 学习辅导",  title: "搭建知识体系，从新手到专家",  href: "#tutor", type: "basic" },
  // 特定场景工作流
  { label: "🏛️ 战略决策", title: "运筹帷幄，共同制定高瞻远瞩的商业策略", href: "#strategy", type: "scenario" },
  { label: "🎨 产品设计", title: "从用户心声到惊艳产品，陪同走完设计全程", href: "#product-design", type: "scenario" },
  { label: "💻 软件开发", title: "从构思到代码，加速软件开发全流程", href: "#software-dev", type: "scenario" },
  // { label: "📱 社媒图文", title: "轻松创作吸睛图文，让你的社交媒体脱颖而出", href: "#graphic-card", type: "scenario" },
  { label: "📈 运营推广", title: "引爆市场，打造刷屏级的营销方案", href: "#promotion", type: "scenario" },
  { label: "📝 媒体矩阵", title: "营造媒体IP，共创高转化率爆款文案", href: "#copywriting", type: "scenario" },
  { label: "📚 小说创作", title: "构建宏大世界，AI助你完成梦想中的长篇故事", href: "#novel-creation", type: "scenario" },
  // { label: "🎵 音乐工坊", title: "捕捉旋律与诗意，和AI一起谱写你的动人乐章", href: "#music-workshop", type: "scenario" },
  // { label: "🎬 电影编剧", title: "从一个好点子到一部电影，AI是你的金牌编剧伙伴", href: "#screenplay", type: "scenario" },
]

export const navlinks_zh: NavLink[] = [
  // SettingNavLink,
  // 基础工作流
  { label: "💬 咨询顾问", title: "驾驭AI梳理思路，一步步辅助你做出更优决策。", href: "#guidance", type: "basic" },
  { label: "🤝 全能助手", title: "一站式AI协作伙伴，跨领域推进项目与内容创作。", href: "#allbasic", type: "basic" },
  { label: "🎓 学习辅导", title: "在AI辅导下搭建知识体系，实现从新手到专家的跃迁。", href: "#tutor", type: "basic" },
  // 特定场景工作流
  { label: "🏛️ 战略决策", title: "借助AI驱动的协同分析，制定端到端的高胜率商业战略。", href: "#strategy", type: "scenario" },
  { label: "🎨 产品设计", title: "从用户洞察到惊艳原型，让AI成为你贯穿全程的设计伙伴。", href: "#product-design", type: "scenario" },
  { label: "💻 软件开发", title: "以AI加速从需求到部署的全流程，实践真正的敏捷开发。", href: "#software-dev", type: "scenario" },
  { label: "📈 运营推广", title: "与AI共同打造抢占先机的营销方案，驱动业务持续增长。", href: "#promotion", type: "scenario" },
  { label: "📝 媒体矩阵", title: "和AI共创高转化内容，规模化打造你的个人或品牌IP。", href: "#copywriting", type: "scenario" },
  { label: "📚 小说创作", title: "让AI助你构建宏大世界，完成你梦想中的史诗故事。", href: "#novel-creation", type: "scenario" },
];

export const navlinks_en: NavLink[] = [
  // SettingNavLink,
  // Basic Workflows
  { label: "💬 Consultant", title: "Leverage AI to structure insights and guide step-by-step decision-making.", href: "#guidance", type: "basic" },
  { label: "🤝 All-Rounder", title: "Your all-in-one AI partner for cross-domain creation and project execution.", href: "#allbasic", type: "basic" },
  { label: "🎓 Tutor", title: "Build your knowledge system with AI, from novice to expert.", href: "#tutor", type: "#basic" },
  // Scenario-Specific Workflows
  { label: "🏛️ Strategy", title: "Formulate end-to-end, high-win-rate strategies with AI-driven analysis.", href: "#strategy", type: "scenario" },
  { label: "🎨 Product Design", title: "From user insights to stunning prototypes, with AI as your end-to-end design partner.", href: "#product-design", type: "scenario" },
  { label: "💻 Software Dev", title: "Accelerate the full agile lifecycle, from requirements to deployment, with AI.", href: "#software-dev", type: "scenario" },
  { label: "📈 Marketing", title: "Craft market-seizing strategies and drive growth with AI.", href: "#promotion", type: "scenario" },
  { label: "📝 Content Matrix", title: "Build your brand IP at scale by co-creating high-conversion content with AI.", href: "#copywriting", type: "scenario" },
  { label: "📚 Novel Writing", title: "Build grand worlds and complete the epic story of your dreams with AI.", href: "#novel-creation", type: "scenario" },
];

export const navlinks = isEn ? navlinks_en : navlinks_zh;


const navScopes = {
  "IMIXBusinessStrategySuite": ["#strategy"],
  "IMIXLearningMentor": ["#tutor","#allbasic"],
  "IMIXAgileDevSuite": ["#product-design", "#software-dev"],
  "IMIXGrowthMarketingPro": ["#copywriting", "#promotion"],
  "IMIXAcademicResearchPro": ["#tutor", "#guidance"],
  "IMIXProductInnovationSuite": ["#strategy", "#product-design"],
  "IMIXContentCreationStudio": ["#copywriting",],
  "IMIXNovelistPro":["#novel-creation"],
  "IMIXUltimateWithNovel":["#guidance", "#allbasic", "#tutor", "#strategy","#product-design", "#software-dev",  "#promotion", "#copywriting", "#novel-creation"],
  "IMIXUltimate":["#guidance", "#allbasic", "#tutor", "#strategy","#product-design", "#software-dev",  "#promotion", "#copywriting"],
} 
//as const;

// 2. 从对象键里取出联合类型
export type NavScope = keyof typeof navScopes; // "IMIXBusinessStrategySuite" | "IMIXLearningMentor" | …
type Href = typeof navlinks[number]['href']; // "#system" | "#strategy" | ...

// 如果你希望把“字符串字面量”和“运行时代码”彻底解耦，可再加一步“反向推导”：
// type NavScope = keyof typeof navScopes;
// 如果你想把 NavScope 当单例维护，也可以反过来：
// const NavScopeValues: NavScope[] = Object.keys(navScopes) as NavScope[];

// const getNavLinks = (navScope:NavScope) => {
//   const hrefs =  navScopes[navScope] || [];
//   // return navlinks.filter((link) => hrefs.includes(link.href));
//   return navlinks.filter(link => hrefs.includes(link.href as Href));
// }

export const getNavLinks = (navScope: NavScope) => {
  const hrefs = (navScopes[navScope] || []) as string[]; // ← 关键
  return navlinks.filter(link => hrefs.includes(link.href));
};

export function ChatFlowNavSelector({
  chatId,
  spaceTag,
  defaultHref, //='#guidance',
  onSelect,
  className,
}: {
  chatId: string;
  spaceTag?: string;
  defaultHref?: string;
  // onSelect?: ((link: any) => void) | undefined;
  onSelect?: (link:any) => void;
  className?: string 
// } & React.ComponentProps<typeof Button>) {
}) {
  const [open, setOpen] = useState(false);

  const [links, setLinks] = useState<NavLink[]>(getNavLinks(process.env.NEXT_PUBLIC_Product_slug as NavScope));//(navlinks);
  const [preFirst, setPreFirst] = useState<boolean>(false);
  const [currentLink, setCurrentLink] = useState<NavLink | null>(navlinks.find(v => v.href === defaultHref)||DefaultNavLink);
      
  // sslog('onUpdateContent-----------links \n product_slug:', {links, product_slug:process.env.NEXT_PUBLIC_Product_slug});

  // const links = useMemo(
  //   () => navlinks.concat(medialinks).concat(medialinks),
  //   [],
  // );
  const router = useRouter();
  const preSelectLink = useMemo(() => {
    setPreFirst(true);
    // sslog('onUpdateContent-----------preSelectLink product_slug:', {defaultHref, product_slug:process.env.NEXT_PUBLIC_Product_slug});
    return navlinks.find(v => v.href === defaultHref) || DefaultNavLink;
  }, [defaultHref])

  const handleSelect=(link:NavLink)=>{
    // console.log('sidebar-handleSelect:' + link.href.slice(1) );
    // console.log('sidebar-handleSelect: link', link );
    
    setCurrentLink(link);
    setPreFirst(false);
    
    onSelect && onSelect(link);

    // setSpaceTag(link.href.slice(1));
    // debounceSelect(link.href);
  }

  // sslog('preFirst &&  preSelectLink.href !== currentLink.href:', {preFirst, defaultHref, preSelectLink:preSelectLink.href, currentLink:currentLink?.href});

  return (
    <div className="relative flex items-center"> {/* 新增包裹容器 */}
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger
          asChild
          className={cn(
            'w-fit data-[state=open]:bg-accent data-[state=open]:text-accent-foreground',
            className,
          )}
        >
          <div className="flex flex-row gap-1 items-start">

          {/* <div
            className={cn(
              "[&_pre]:my-0 [&_pre]:max-h-[650px] [&_pre]:pb-[100px]",
              open ? "[&_pre]:overflow-hidden" : "[&_pre]:overflow-auto]",
            )}
          > */}        
          <Button
            variant="outline"
            className="relative flex md:flex md:px-2 md:h-[34px]"
            onClick={(e) => {
              const sidebarBody = e.currentTarget as HTMLElement; // 获取组件的边界信息
              const rect = sidebarBody.getBoundingClientRect();  // 获取鼠标离开时的坐标
              const mouseX = e.clientX;
              if (mouseX >= rect.right - 28) { // // 判断鼠标是否从右侧离开 5是容差值，可以根据需要调整
                  setOpen(true);
                  // setAnimate(false);
                  toast('mouseX >= rect.right')
              }
              console.log('Mouse  mouseX rect', mouseX, rect );
              if (mouseX <= rect.left + 28) { // 5是容差值，可以根据需要调整
                  // setOpen(false); // 打开光标从左侧移除时，列表会消失
                  // setAnimate(true);

                  toast('mouseX <= rect.left')
              }
            }}
          >
            {/* {preFirst? preSelectLink?.icon : currentLink.icon} */}
            {preFirst? preSelectLink?.label : currentLink?.label || ''}
            {/* <div onClick={(e)=>{e.stopPropagation(); e.preventDefault(); toast('add new chat') }}><PlusIcon /></div> */}
            <ChevronDownIcon  />
          </Button>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[300px]">
          {links.map((link, idx) => (
            <DropdownMenuItem
              key={link.href + idx}
              onSelect={() => {
                handleSelect(link);
                setOpen(false);
              }}
              className="gap-4 group/item flex flex-row justify-between items-center"
              data-active={link.href === currentLink?.href}
            >
              <div className="flex flex-col gap-1 items-start">
                {link.label}
                {link.title && (
                  <div className="text-xs text-muted-foreground">
                    {link.title}
                  </div>
                )}
              </div>
              <div className="text-foreground dark:text-foreground opacity-0 group-data-[active=true]/item:opacity-100">
                <CheckCircleFillIcon />
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      {preFirst &&  preSelectLink.href !== currentLink?.href  && <div
        onMouseOver={()=>{
          // const pathname = usePathname();
          sslog('pathname = usePathname()', window.location.origin);
          // toast('add new chat' + window.location.origin);
        }}
        onClick={(e) => {
          // e.preventDefault();
          // e.stopPropagation(); // 阻止 React 事件冒泡
          // e.nativeEvent.stopImmediatePropagation(); // 阻止原生事件
          //
          setCurrentLink(preSelectLink);
          handleSelect(preSelectLink);
          setOpen(false);
          const pathname = window.location.origin; //usePathname();

          sslog('pathname = usePathname()', pathname);
          // toast('add new chat' + pathname);

          if (pathname !== '/') {
            // router.push('/');
            // router.refresh();

            // window.history.replaceState({}, '', `/`);
            // router.refresh();

          } else {
            // router.refresh();
          }
        }}
        className={cn(
          // "absolute  flex items-center justify-center bg-gradient-to-b from-background/10 to-background to-90% p-0",
          "absolute opacity-80 bg-red-800 w-full h-full top-0 left-0 flex items-end justify-center bg-gradient-to-b from-background/10 to-background to-90% p-0",
          !open ? "inset-x-0 bottom-0 h-full" : "inset-0 ",
            "ignore-dropdown-trigger rounded-tl-full"
        )}
      ></div>}
    </div>
  );
}

export function FloatingActionAddChat({onSelect}:{onSelect?: (link:any) => void;}) {
  const [links, setLinks] = React.useState<NavLink[]>(navlinks);
  // const [currentLink, setCurrentLink] = React.useState<NavLink>(defaultLink);
  const handleSelect=(link:NavLink)=>{
    console.log('sidebar-handleSelect AddChat:' + link.href.slice(1) );
    console.log('sidebar-handleSelect AddChat: link', link );

    // setCurrentLink(link);
    onSelect && onSelect(link);

    // setSpaceTag(link.href.slice(1));
    // debounceSelect(link.href);
  }

  return (
    <div className="flex  items-center justify-center ">
      <FloatingActionPanelRoot>
        {({ mode: string, closePanel }) => (
          <>
            <div className="flex items-center text-base">
              <FloatingActionPanelTrigger className="text-2xl pr-2 pl-1 h-8 bg-transparent dark:bg-transparent  border-b boreder-1" title="创建新协作，请选择任务类型" mode="actions">
                {/* <Plus className="size-4" /> */}
                {/* <ArrowRightIcon /> */}

                <div className="space-y-0 text-center">
                  <ComicText className="left-0 ml-0 text-center" fontSize={0.6}>AIGex</ComicText>
                </div>
              </FloatingActionPanelTrigger>
            </div>

            <FloatingActionPanelContent>
              <div className="space-y-1 p-2">
                {/* <FloatingActionPanelButton onClick={() => {console.log("New Project"); closePanel()}}>
                  <Plus className="size-4" />
                  New Project
                  <Plus className="size-4" />
                </FloatingActionPanelButton>
                <FloatingActionPanelButton onClick={() => {console.log("Upload Assets"); closePanel()}}>
                  <Upload className="h-4 w-4" />
                  Upload Assets
                  <Upload className="h-4 w-4" />
                </FloatingActionPanelButton>
                <FloatingActionPanelButton onClick={() => {console.log("Theme Settings"); closePanel()}}>
                  <Palette className="h-4 w-4" />
                  Theme Settings
                </FloatingActionPanelButton>
                <FloatingActionPanelButton onClick={() => {console.log("Share"); closePanel()}}>
                  <Share2 className="h-4 w-4" />
                  Share Project
                </FloatingActionPanelButton>
                <FloatingActionPanelButton onClick={() => {console.log("Save Template"); closePanel()}}>
                  <BookMarked className="h-4 w-4" />
                  Save as Template
                </FloatingActionPanelButton> */}

                {links.map((link, idx) => (
                  <motion.div
                    key={link.href + idx}
                    onSelect={() => {
                      // closePanel();
                      // handleSelect(link);
                      // setOpen(false);
                    }}
                    // className="gap-4 group/item flex flex-row justify-between items-center"
                    // data-active={link.href === currentLink.href}
                    className="flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-sm text-zinc-900 hover:bg-zinc-100 dark:text-zinc-50 dark:hover:bg-zinc-800"
                    // className
                  >
                    {/* {link.icon} */}
                    <button onClick={()=>{ handleSelect(link); closePanel();}} className="flex flex-col gap-1 items-start">
                      {/* <Plus className="size-4" /> */}
                      {link.label}
                      {link.title && (
                        <div className="text-xs text-muted-foreground">
                          {link.title}
                        </div>
                      )}
                    </button>
                    {/* <div className="text-foreground dark:text-foreground opacity-0 group-data-[active=true]/item:opacity-100">
                      <CheckCircleFillIcon />
                    </div> */}
                  </motion.div>
                ))}

              </div>



            </FloatingActionPanelContent>
          </>
        )}
      </FloatingActionPanelRoot>
    </div>
  )
}
